<template>
  <div class="open-member-tips">
    <div class="open-member" v-if="userInfo">
      <div class="member-intro">
        <p>立即开通{{userInfo.top_member.name}}</p>
        <p v-show="discounts * 1 > 0">
          本次订单可为您节省
          <em>{{discounts}}</em> 元
        </p>
      </div>
      <button @click="$router.push({name: 'memberCenter'})">去开通</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'openMemberTips',
  props: {
    discounts: {
      type: [Number, String]
    }
  },
  computed: {
    ...mapState('store', [
      'userInfo'
    ])
  }
}
</script>

<style lang="less" scoped>
.open-member {
  position: relative;
  width: 6.9rem;
  height: 1.55rem;
  margin: 0 auto;
  background: linear-gradient(
    180deg,
    rgba(30, 62, 117, 1) 0%,
    rgba(18, 33, 57, 1) 100%
  );
  border-radius: 0.1rem;
  font-size: @fz28;
  font-weight: 660;
  color: #fff;
  .flex-between;
  margin-bottom: 0.4rem;
  .member-intro {
    display: flex;
    flex-direction: column;
    p {
      padding-left: 0.32rem;
      em {
        color: #ff9600;
      }
    }
  }
  button {
    margin-right: 0.26rem;
    width: 1.96rem;
    height: 0.78rem;
    background-color: #f1c40f;
    border-radius: 30px;
    font-size: 0.32rem;
    color: #b53900;
  }
}
</style>
